import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Cuéntanos tu proyecto',
  text: 'Escríbenos por WhatsApp y explícanos qué necesitas construir, remodelar o mejorar.'
}, {
  number: '02',
  title: 'Recibe orientación y presupuesto',
  text: 'Revisamos tu caso y preparamos un presupuesto gratuito según el alcance del trabajo.'
}, {
  number: '03',
  title: 'Avanza con respaldo',
  text: 'Trabajamos con contrato ante notaría y garantía de 5 años para mayor tranquilidad.'
}];
export function Process() {
  return <section className="py-20 bg-white" data-id="element-120">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy" data-id="element-123">
            ¿Cómo funciona?
          </motion.h2>
        </div>

        <div className="max-w-5xl mx-auto relative" data-id="element-124">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-200 -z-10" data-id="element-125"></div>

          <div className="grid md:grid-cols-3 gap-12" data-id="element-126">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative text-center" data-id="element-127">
                <div className="w-24 h-24 mx-auto bg-white border-4 border-orange rounded-full flex items-center justify-center text-3xl font-bold text-navy mb-6 shadow-lg" data-id="element-128">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-navy mb-4" data-id="element-129">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-130">{step.text}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}